import { render } from "./manager-script-margin-limit.vue?vue&type=template&id=764560b1&scoped=true"
import script from "./manager-script-margin-limit.vue?vue&type=script&lang=js"
export * from "./manager-script-margin-limit.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./manager-script-margin-limit.vue?vue&type=style&index=1&id=764560b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764560b1"]])

export default __exports__